import { createAsyncThunk } from '@reduxjs/toolkit';
import { toastHandler } from '../../../utils/toastHandler';
import { FindPurchasePlan, GetPurchasePlan } from './interface';
import { PurchasePlan } from '../../../client/services';

export const findPurchasePlan = createAsyncThunk(
  'purchasePlan/findPurchasePlan',
  async (values: FindPurchasePlan, { rejectWithValue }) => {
    try {
      const response = await PurchasePlan.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPurchasePlan = createAsyncThunk(
  'purchasePlan/getPurchasePlan',
  async ({ id }: GetPurchasePlan, { rejectWithValue }) => {
    try {
      const response = await PurchasePlan.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
